export default __webpack_public_path__ + "static/SRUS HF102 - Product Specifications & Technical Data-885077d3e8ed47e5f0b13c7fa88a80ae.pdf";